import { Tooltip } from '@chakra-ui/react';
import { useTokens } from '@mezzoforte/forge';
import { Info } from '@mezzoforte/forge-icons';
import { ReactNode, useState } from 'react';

interface TooltipInfoProps {
  label: ReactNode;
}

const { colors } = useTokens.huutokaupat;

function InfoTooltip({ label }: TooltipInfoProps) {
  const [tooltipVisible, setTooltipVisible] = useState(false);

  return (
    <Tooltip
      hasArrow
      label={label}
      isOpen={tooltipVisible}
    >
      <Info
        color={colors.success}
        weight="fill"
        size="20"
        style={{ verticalAlign: 'text-bottom', marginLeft: 4 }}
        onMouseEnter={() => setTooltipVisible(true)}
        onMouseLeave={() => setTooltipVisible(false)}
        onClick={() => setTooltipVisible(!tooltipVisible)}
      />
    </Tooltip>
  );
}
export default InfoTooltip;
